var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgValidationTicketPlaceholder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    rx: 2.084,
    fill: "#fff"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.097 36.11l3.89 3.89L40 20.985l-3.89-3.889M12.777 31.789L8.887 27.9 27.9 8.887l3.89 3.889M36.543 17.528a3.667 3.667 0 11-5.186-5.185M17.53 36.543a3.667 3.667 0 10-5.186-5.186M21.85 14.937l2.16 2.16M25.308 18.394l1.728 1.728M28.765 21.85l1.728 1.728M33.95 27.036l-2.16-2.16",
    stroke: "#AFAFAF",
    strokeWidth: 1.157
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgValidationTicketPlaceholder);
export default __webpack_public_path__ + "static/media/validation-ticket-placeholder.5680ab26.svg";
export { ForwardRef as ReactComponent };